<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: zusatzangaben }"></ng-template>

<ng-template #typ00>
  @if (zusatzangaben) {
    <ng-template [ngTemplateOutlet]="erwerbsartDatum"></ng-template>
    @if (zusatzangaben?.beleg?.geschaeftId) {
      <cap-kompakt-beleg
        [item]="zusatzangaben.beleg"
        [mitDatum]="false"
        [referenzObjectId]="zusatzangaben.beleg?.geschaeftId"
        [referenzObjectType]="'GRUNDBUCHGESCHAEFT'"
        format="BELEG_TYP01">
      </cap-kompakt-beleg>
    } @else {
      @if (zusatzangaben.beleg) {
        <cap-kompakt-beleg
          [item]="zusatzangaben.beleg"
          [mitDatum]="false"
          [referenzObjectId]="referenzObjectId"
          [referenzObjectType]="'GRUNDBUCHMELDUNG'">
        </cap-kompakt-beleg>
      }
    }
    <cap-read-more [text]="text"></cap-read-more>
  }

  <ng-template #erwerbsartDatum>
    <a (click)="openZusatzangaben()" [ngbTooltip]="tooltipZusatzangaben | translate" class="linkAsText" style="cursor: pointer">
      <span> {{ zusatzangaben.erwerbsart }}: </span>
      {{ zusatzangaben.beleg?.datum | datum }}
    </a>
  </ng-template>
</ng-template>
